import { AddressBase } from '../address-base.model';

export class InsurerRegistrationData {
  firstName: string;
  lastName: string;
  pesel: string;
  birthDate: Date;
  address: AddressBase;

  constructor() {
    this.address = new AddressBase();
  }
}
